import React from 'react';
import PropTypes from 'prop-types';

import './style.scss';

const UndoDeleteShape = ({ setShapeHasBeenDeleted }) => {
  const action = () => {
    history.back();
    setShapeHasBeenDeleted(false);
  }

  return setShapeHasBeenDeleted ? (
    <div className="undoDeleteShape p--s c-bg--secondary">
      <p className="undoDeleteShape__msg c-txt--w tp-s--s tp-w--m">L'area di ricerca<br />è stata cancellata</p>
      <button
        type="button"
        onClick={action}
        className="undoDeleteShape__btn ml--s tp-s--s tp-w--m c-txt--w c-bg--secondary b--s c-br--borderdark is-clickable"
      >
        Annulla
      </button>
    </div>
  ) : null;
};

export default UndoDeleteShape;

UndoDeleteShape.propTypes = {
  setShapeHasBeenDeleted: PropTypes.func,
};

UndoDeleteShape.defaultProps = {
  setShapeHasBeenDeleted: null,
};